import React, { Component } from "react";
import "./NodeModal.css";
import InfoIcon from "./InfoIcon";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
} from "reactstrap";

export default class NodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      network: this.props.network,
      validationError: [],
      contactPlan: this.props.network.contact_plan
        ? this.props.network.contact_plan.replace(new RegExp("%10%", "g"), '\n')
        : "",
      isValid: true,
      loading:false,
    };
  }

  validateInput = () => {
    let errors = [];

    if (errors.length > 0) {
      this.setState({
        isValid: false,
        validationErrors: errors,
      });
      return false;
    }
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = async (e) => {
    let { name, value } = e.target;
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
    await this.setState({ [name]: value });
  };
  render() {
    const { toggle, getErrors, onSave } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={toggle}>
        <ModalHeader>
          Enter Custom Contact Plan
          <InfoIcon
            infoText={
              "The entered contact plan will be saved and distributed to nodes accross the network."
            }
            position={"right"}
          />
          <button className="exit_close_button" onClick={toggle}>
            ×
          </button>
        </ModalHeader>

        <div className="val_error_area">
          <ul style={{ color: "red" }}>
            {this.state.isValid ? getErrors() : this.state.validationErrors}
          </ul>
        </div>
        <ModalBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Input
                type="textarea"
                name="contactPlan"
                value={this.state.contactPlan}
                onChange={this.handleChange}
                placeholder="a contact +0 +3600 1 2 10000 ..."
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <button
            className={`api_button ${this.state.apiModal ? "active" : null}`}
            onClick={() => {
              this.setState({ apiModal: !this.state.apiModal });
            }}
          >
            API Call
          </button>
          <button
            className="save_button"
            disabled={this.state.loading}
            onClick={() => {
              if (this.validateInput()) {
                this.setState({ loading: true });
                // eslint-disable-next-line
                onSave(this.state.contactPlan.replace(new RegExp("\n", "g"), '%10%'));
              }
            }}
          >
            {this.state.loading ? "Loading..." : "Update"}
          </button>
          {this.state.apiModal ? (
            <div className="generated_area">
              <h4 style={{ color: "#60f056" }}>API Call</h4>
              <p>Edit node attributes remotely with:</p>
              <code style={{ color: "white" }}>
                
                {
                // eslint-disable-next-line
                `curl -X POST -F 'me=${this.props.token}' -F 'network=${this.state.network.uuid}' -F "contact_plan=${this.state.contactPlan.replace(new RegExp("\n", "g"), '%10%')}" ${this.props.baseUrl}/api/add-contact`
                }
              </code>
            </div>
          ) : null}
        </ModalFooter>
      </Modal>
    );
  }
}
